import { memo } from 'react';
import { AccordionIdentityCard as AccordionIdentityCardVM } from 'shell/view-models/accordion-identity-card';
import { Divider, Grid } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import MunicipalityList from 'shell/components/shared/municipality-list';
import { FormikErrors, FormikTouched } from 'formik';

interface IdentityCardProps {
  values?: AccordionIdentityCardVM;
  errors?: FormikErrors<AccordionIdentityCardVM>;
  touched?: FormikTouched<AccordionIdentityCardVM>;
  onChange: (
    key: keyof AccordionIdentityCardVM,
    value: AccordionIdentityCardVM[keyof AccordionIdentityCardVM]
  ) => void;
}

const MunicipalityReleaseComponent = ({
  values,
  onChange,
  touched,
  errors,
}: IdentityCardProps): React.ReactElement => {
  return (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Comune rilascio</PmiTitleDivider>
      </Grid>
      <Grid item xs={12} md={7}>
        <MunicipalityList
          label="Comune"
          aria-label="Comune"
          value={values?.municipality || null}
          error={touched?.municipality && !!errors?.municipality}
          onChange={(value) => {
            onChange('municipality', value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Provincia"
          inputProps={{
            maxLength: '2',
          }}
          aria-label="Provincia"
          fullWidth
          onChange={(event) => {
            onChange('province', event?.target.value);
          }}
          value={values?.municipality?.province || ''}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={7}>
        <PmiTextField
          label="Località"
          aria-label="Località"
          fullWidth
          onChange={(event) => {
            onChange('location', event?.target.value);
          }}
          value={values?.location || ''}
          error={touched?.location && !!errors?.location}
          helperText={errors?.location}
        />
      </Grid>
    </Grid>
  );
};

MunicipalityReleaseComponent.displayName = 'Municipality Release component';

const MunicipalityRelease = memo(MunicipalityReleaseComponent);

export default MunicipalityRelease;
